var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.058,
    height: 68.798,
    viewBox: "0 0 58.058 68.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Congrats",
    transform: "translate(-939.068 -390.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up",
    d: "M28.043,16.358V7.011A7.011,7.011,0,0,0,21.032,0L11.685,21.032V46.738h26.36a4.674,4.674,0,0,0,4.674-3.973l3.225-21.032a4.674,4.674,0,0,0-4.674-5.375ZM11.685,46.738H4.674A4.674,4.674,0,0,1,0,42.065V25.706a4.674,4.674,0,0,1,4.674-4.674h7.011",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 941.385, 411.427)",
    fill: "none",
    stroke: "#58299c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x1: 7.817,
    y1: 5.472,
    transform: "translate(947.377 401.442)",
    fill: "none",
    stroke: "#58299c",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x1: 2.345,
    y1: 7.817,
    transform: "translate(958.321 392.843)",
    fill: "none",
    stroke: "#58299c",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x1: 1.563,
    y2: 8.599,
    transform: "translate(970.047 394.406)",
    fill: "none",
    stroke: "#58299c",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/Congrats.a3ddec9c.svg";
export { ForwardRef as ReactComponent };